import React from 'react'

const MainLogo = ({ minimal, whitemode }) => {

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{
            fillRule: "evenodd",
            clipRule: "evenodd",
            strokeLinejoin: "round",
            strokeMiterlimit: 2,
            }}
            viewBox={minimal ? '0 0 126 47' : '0 0 199 47'}
        >
            {!minimal &&
                <g id="mga-tagline">
                    <path
                    d="M520.689 307.423V300.1h1.475l1.5 5.77 1.415-5.77h1.475v7.324h-.881v-6.344l-1.6 6.344h-.812l-1.692-6.344v6.344l-.88-.001Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-389.604 -283.266)"
                    />
                    <path
                    d="M545.634 309.248c0-1.554.653-2.841 2.108-2.841s2.1 1.287 2.1 2.851-.653 2.85-2.1 2.85-2.108-1.277-2.108-2.85v-.01Zm.92.02c0 1.4.416 2.029 1.2 2.029.762 0 1.178-.633 1.178-2.039 0-1.406-.416-2.029-1.2-2.029-.762 0-1.178.633-1.178 2.029v.01Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-407.661 -287.832)"
                    />
                    <path
                    d="M564.379 306.526h.8c0 .426 0 .713-.01 1.01a1.361 1.361 0 0 1 1.435-1.128v1.039a.614.614 0 0 0-.356-.1c-.465 0-1 .515-1 1.633v3.009h-.871l.002-5.463Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-421.23 -287.832)"
                    />
                    <path
                    d="M574.51 309.544c0 .94.366 1.752 1.178 1.752a1.058 1.058 0 0 0 1.039-.95h.861a2.166 2.166 0 0 1-.712 1.366 1.886 1.886 0 0 1-1.188.4c-1.484 0-2.1-1.386-2.1-2.841 0-1.663.752-2.86 2.079-2.86a1.686 1.686 0 0 1 1.5.8c.379.717.541 1.529.465 2.336l-3.122-.003Zm2.257-.752c-.02-.871-.347-1.653-1.109-1.653-.683 0-1.128.663-1.148 1.653h2.257Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-427.897 -287.832)"
                    />
                    <path
                    d="M594.774 311.989h-.8v-.871c-.16.59-.705 1-1.316.99-1.049 0-1.791-1.049-1.791-2.841 0-1.742.663-2.86 1.791-2.86a1.312 1.312 0 0 1 1.316 1.02v-.9h.8v5.462Zm-3.038-2.722c0 1.227.386 1.98 1.089 1.98a.901.901 0 0 0 .812-.485 4.372 4.372 0 0 0 0-3.009.914.914 0 0 0-.812-.485c-.7 0-1.089.762-1.089 1.989v.01Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-440.402 -287.832)"
                    />
                    <path
                    d="M613.168 312.3h-.8c0-.277 0-.534.01-.831-.18.601-.76.999-1.386.95-.921 0-1.524-.515-1.524-1.762v-3.82h.881v3.533c0 .495.079 1.188.871 1.188.643 0 1.079-.426 1.079-1.346v-3.375h.871l-.002 5.463Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-453.866 -288.144)"
                    />
                    <path
                    d="M639.7 302.21a2.234 2.234 0 0 0-.277-1.01 1.274 1.274 0 0 0-1.188-.7c-1.069 0-1.752.95-1.752 2.9 0 2.049.713 2.9 1.752 2.9a1.3 1.3 0 0 0 1.237-.722c.22-.445.319-.94.287-1.435h-1.809v-.9h2.811v1.188a2.59 2.59 0 0 1-2.524 2.771c-1.88 0-2.751-1.554-2.751-3.8 0-2.276 1.01-3.8 2.751-3.8h.002a2.469 2.469 0 0 1 2.452 2.613l-.991-.005Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-472.701 -282.903)"
                    />
                    <path
                    d="M657.349 309.248c0-1.554.653-2.841 2.108-2.841s2.1 1.287 2.1 2.851-.653 2.85-2.1 2.85-2.108-1.277-2.108-2.85v-.01Zm.92.02c0 1.4.416 2.029 1.2 2.029.762 0 1.178-.633 1.178-2.039 0-1.406-.416-2.029-1.2-2.029-.762 0-1.178.633-1.178 2.029v.01Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-488.527 -287.832)"
                    />
                    <path
                    d="M676.094 306.526h.772c0 .267 0 .515-.01.8a1.412 1.412 0 0 1 1.416-.92c.91 0 1.514.525 1.514 1.772v3.81h-.871v-3.523c0-.5-.079-1.2-.881-1.2-.643 0-1.069.435-1.069 1.356v3.365h-.871v-5.46Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-502.096 -287.832)"
                    />
                    <path
                    d="m692.472 311.489 2.425-3.83h-2.237v-.822h3.276v.831l-2.405 3.81H696v.822h-3.523l-.005-.811Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-513.951 -288.144)"
                    />
                    <path
                    d="M711.614 311.989h-.8v-.871c-.16.59-.705 1-1.316.99-1.049 0-1.791-1.049-1.791-2.841 0-1.742.663-2.86 1.791-2.86a1.312 1.312 0 0 1 1.316 1.02v-.9h.8v5.462Zm-3.039-2.722c0 1.227.386 1.98 1.089 1.98a.901.901 0 0 0 .812-.485 4.372 4.372 0 0 0 0-3.009.914.914 0 0 0-.812-.485c-.7 0-1.089.762-1.089 1.989v.01Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-524.978 -287.832)"
                    />
                    <path
                    d="M726.736 300.1h.871v7.324h-.871z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-538.754 -283.266)"
                    />
                    <path
                    d="M734.823 309.544c0 .94.366 1.752 1.178 1.752a1.058 1.058 0 0 0 1.039-.95h.861a2.165 2.165 0 0 1-.713 1.366 1.886 1.886 0 0 1-1.188.4c-1.484 0-2.1-1.386-2.1-2.841 0-1.663.752-2.86 2.078-2.86a1.686 1.686 0 0 1 1.5.8c.379.717.541 1.529.465 2.336l-3.12-.003Zm2.257-.752c-.02-.871-.347-1.653-1.109-1.653-.683 0-1.128.663-1.148 1.653h2.257Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-543.942 -287.832)"
                    />
                    <path
                    d="m750.712 311.489 2.424-3.83H750.9v-.822h3.276v.831l-2.4 3.81h2.464v.822h-3.523l-.005-.811Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-556.109 -288.144)"
                    />
                    <path
                    d="m525.2 336.7-1.178 2.306 1.257 1.5-.673.594-1.049-1.287a2.473 2.473 0 0 1-1.93 1.376h-.008a2.051 2.051 0 0 1-2.041-2.118 2.452 2.452 0 0 1 1.494-2.267 2.268 2.268 0 0 1-.742-1.515l-.001-.057c0-.901.742-1.643 1.643-1.643h.011a1.62 1.62 0 0 1 1.594 1.613v.02a2.122 2.122 0 0 1-1.208 1.792l1.069 1.287.792-1.6.97-.001Zm-3.523.822a1.65 1.65 0 0 0-1.103 1.551c0 .627.504 1.149 1.131 1.171.673 0 1.039-.7 1.257-1.128l-1.285-1.594Zm.287-3.128a.76.76 0 0 0-.752.8c.059.459.293.878.653 1.168.544-.327.832-.683.832-1.138a.789.789 0 0 0-.723-.831l-.01.001Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-388.8 -307.512)"
                    />
                    <path
                    d="M549.751 341.419h-1l2.059-7.324h.94l2.108 7.324h-1l-.544-1.92h-2.029l-.534 1.92Zm1.544-5.988-.762 3.167h1.524l-.762-3.167Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-409.917 -307.875)"
                    />
                    <path
                    d="M570.692 342.007c-.01-.6-.307-.841-.782-.841l-.039-.001a.659.659 0 0 0-.654.694c0 .564.554.723 1.2.92a1.588 1.588 0 0 1 1.277 1.653v.034c0 .9-.74 1.641-1.641 1.641l-.081-.002a1.692 1.692 0 0 1-1.793-1.682c0-.03 0-.06.002-.09h.861a.905.905 0 0 0 .896.981l.045-.001.045.001a.761.761 0 0 0 .755-.823c0-.6-.515-.792-1.208-1.019a1.544 1.544 0 0 1-1.267-1.584 1.632 1.632 0 0 1 1.62-1.488c.885 0 1.616.722 1.626 1.607h-.862Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-423.98 -312.442)"
                    />
                    <path
                    d="M583.374 343.245c0-1.554.653-2.841 2.108-2.841s2.1 1.287 2.1 2.851-.653 2.85-2.1 2.85-2.108-1.277-2.108-2.85v-.01Zm.92.02c0 1.4.416 2.029 1.2 2.029.762 0 1.178-.633 1.178-2.038 0-1.405-.416-2.029-1.2-2.029-.762 0-1.178.633-1.178 2.029v.009Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-434.979 -312.442)"
                    />
                    <path
                    d="M604.87 344.056c-.079 1.118-.663 2.049-1.791 2.049-1.405 0-2.108-1.247-2.108-2.841 0-1.8.831-2.86 2.088-2.86 1.148 0 1.762.92 1.792 2.069h-.891c-.079-.94-.485-1.247-.94-1.247a.867.867 0 0 0-.831.5 3.167 3.167 0 0 0-.3 1.524c0 1.375.416 2.038 1.128 2.038.584 0 .881-.5.95-1.237l.903.005Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-447.717 -312.442)"
                    />
                    <path
                    d="M618.39 334.1h.871v1.01h-.871v-1.01Zm0 1.861h.871v5.463h-.871v-5.463Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-460.326 -307.875)"
                    />
                    <path
                    d="M629.359 345.986h-.8v-.871c-.16.59-.705 1-1.316.99-1.049 0-1.791-1.049-1.791-2.841 0-1.742.663-2.86 1.791-2.86a1.312 1.312 0 0 1 1.316 1.02v-.9h.8v5.462Zm-3.038-2.722c0 1.227.386 1.98 1.089 1.98a.901.901 0 0 0 .812-.485 4.372 4.372 0 0 0 0-3.009.914.914 0 0 0-.812-.485c-.7 0-1.089.762-1.089 1.989v.01Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-465.437 -312.442)"
                    />
                    <path
                    d="M647.029 341.419h-.8v-.93a1.325 1.325 0 0 1-1.316 1.049c-1.049 0-1.791-1.049-1.791-2.841 0-1.742.663-2.86 1.791-2.86a1.262 1.262 0 0 1 1.257.96c-.01-.267-.01-.514-.01-.841V334.1h.871l-.002 7.319Zm-3.039-2.722c0 1.218.386 1.98 1.089 1.98a.914.914 0 0 0 .812-.485c.23-.464.322-.985.267-1.5a2.683 2.683 0 0 0-.267-1.5.901.901 0 0 0-.812-.485c-.7 0-1.089.752-1.089 1.989v.001Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-478.227 -307.875)"
                    />
                    <path
                    d="M660.789 343.245c0-1.554.653-2.841 2.108-2.841s2.1 1.287 2.1 2.851-.653 2.85-2.1 2.85-2.108-1.277-2.108-2.85v-.01Zm.92.02c0 1.4.416 2.029 1.2 2.029.762 0 1.178-.633 1.178-2.038 0-1.405-.416-2.029-1.2-2.029-.762 0-1.178.633-1.178 2.029v.009Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-491.017 -312.442)"
                    />
                    <path
                    d="M680.757 342.007c-.01-.6-.307-.841-.782-.841l-.039-.001a.659.659 0 0 0-.654.694c0 .564.554.723 1.2.92a1.588 1.588 0 0 1 1.277 1.653v.034c0 .9-.74 1.641-1.641 1.641l-.081-.002a1.692 1.692 0 0 1-1.793-1.682c0-.03 0-.06.002-.09h.861c-.002.027-.004.054-.004.081 0 .494.407.9.9.9l.044-.001.045.001a.761.761 0 0 0 .755-.823c0-.6-.515-.792-1.207-1.019a1.545 1.545 0 0 1-1.267-1.584 1.632 1.632 0 0 1 1.62-1.488c.885 0 1.616.722 1.626 1.607h-.862Z"
                    style={{
                        fill: whitemode ? '#FFFFFF' : "#505257",
                        fillRule: "nonzero",
                    }}
                    transform="translate(-503.651 -312.442)"
                    />
                </g>
            }
            <path
            d="M89.053 254.458v1.871l6.012-6.012c-.2-5.761-5.2-11.175-13.171-11.175-4.753 0-8.215 1.467-10.739 5.457-1.7-3.638-6.278-5.457-10.092-5.457-4.284 0-6.631 1.232-9.33 4.4h-.118v-3.521h-5.633v32.508h6.1V254.4c0-5.457 1.76-9.683 8.039-9.683a6.727 6.727 0 0 1 6.044 3.052c1.35 2.17 1.35 4.224 1.35 6.689v18.073h6.1V254.4c0-5.341 1.408-9.683 7.746-9.683 5.991-.001 7.692 4.635 7.692 9.741Z"
            style={{
                fill: whitemode ? '#FFFFFF' : "#E9540D",
                fillRule: "nonzero",
            }}
            transform="translate(-45.982 -239.142)"
            />
            <path
            d="M305.559 240.022v4.578h-.117c-2.407-3.7-6.69-5.457-11.032-5.457-7.588-.193-14.406 4.789-16.527 12.078l-9.868 9.953v-.036s-.34.361-.831.874l-2.77 2.794a10.78 10.78 0 0 1-7.624 2.973c-6.206-.137-11.231-5.292-11.208-11.5 0-.307.022-.609.045-.911l-5.455 5.454c2.224 7.348 9 12.44 16.676 12.532 4.284 0 8.626-1.526 11.208-5.1h.118c0 7.452-4.049 11.5-11.442 11.5a10.695 10.695 0 0 1-9.272-4.694h-6.807a16.942 16.942 0 0 0 16.019 10.269c10.8 0 17.6-6.221 17.6-17.194v-4.956l3.211-3.272c1.558 7.954 8.381 13.451 16.917 13.451a12.447 12.447 0 0 0 11.032-5.868h.117v5.047h6.1v-32.515h-6.09Zm-11.207 27.756c-6.163-.139-11.144-5.277-11.091-11.442 0-6.338 4.695-11.619 11.149-11.619 6.631 0 11.266 5.106 11.266 11.619v.085c0 6.218-5.107 11.34-11.325 11.357h.001Z"
            style={{
                fill: whitemode ? '#FFFFFF' : "#505257",
                fillRule: "nonzero",
            }}
            transform="translate(-186.552 -239.142)"
            />
            <path
            d="M240.477 240.022v3.756c-2.7-3.052-7.218-4.636-11.208-4.636a17.291 17.291 0 0 0-11.092 3.79l-.006-.008-.066.066a16.472 16.472 0 0 0-2.225 2.225l-13.972 13.972.053.053h-.039v13.291h6.1v-11.012l12.088-12.3a.489.489 0 0 0 .237-.136c.222-.286.459-.56.706-.824l.359-.366a11.002 11.002 0 0 1 7.738-3.172c1.47.026 2.923.325 4.284.88 4.694 1.819 7.042 5.751 7.042 10.739a9.44 9.44 0 0 1-.135 1.482l6.238-6.238v-11.562h-6.102Z"
            style={{
                fill: whitemode ? '#FFFFFF' : "#EF7D10",
                fillRule: "nonzero",
            }}
            transform="translate(-158.85 -239.142)"
            />
        </svg>
    )
}

export default MainLogo